// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"PayPal_buttonWrapper__PIIjo","loading":"PayPal_loading__jjvfO"};